import styled from "styled-components";
import { mediaMaxWidth } from "../../../../theme/mediaQueriesTemplates";

export const Filter = styled.div`
  position: absolute;
  margin-top: 4px;
  color: #fff;
`;

export const FilterTriggerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.85em;
  }
`;

export const FilterTrigger = styled.div`
  font-weight: 700;
  cursor: pointer;
  text-transform: capitalize;
  display: flex;

  svg.fa-chevron-down {
    margin-top: 4.5px;
  }

  ${mediaMaxWidth.phone} {
    svg.fa-chevron-down {
      font-size: 0.85em;
      margin-right: 7px;
      margin-top: 5px;
    }
  }
`;

export const FilterTriggerInner = styled.div`
  font-size: 0.94em;
  padding: 2px 10px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;

  ${mediaMaxWidth.phone} {
    font-size: 0.9em;
    padding: 2px 7px;
  }
`;

interface IFilterOptionsProps {
  active: boolean;
}

export const FilterOptions = styled.div`
  color: black;
  position: absolute;
  top: 32px;
  cursor: pointer;
  width: 177px;
  text-align: left;
  box-shadow: rgb(214, 214, 214) 0px 0px 5px;
  opacity: 1;
  z-index: 7;
  left: ${(props: IFilterOptionsProps) =>
    props.active ? "calc(100% - 2.8em)" : "-150px"};
  opacity: ${(props: IFilterOptionsProps) => (props.active ? "1" : "0")};
  pointer-events: ${(props: IFilterOptionsProps) =>
    props.active ? "auto" : "none"};
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.2s ease-in-out 0s;
  padding: 37.5px 5px 2.5px 5px;

  &::after,
  &::before {
    bottom: 100%;
    left: 30px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }

  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #eaeaea;
    border-width: 10px;
    margin-left: -2px;
  }

  ${mediaMaxWidth.tablet} {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
    padding: 40px 5px 2.5px 5px;
  }
`;

export const FilterOption = styled.div`
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  text-transform: capitalize;
  margin: 2.5px;
  position: relative;
  display: flex;
  flex-basis: 100%;
  justify-content: space-between;

  svg {
    position: absolute;
    right: 8px;
    top: 9px;
    font-size: 0.8em;
  }

  &:hover {
    background-color: #79D9D9;
    color: #fff;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 1.5em;
    padding: 10px;

    &:hover {
      background-color: #fff;
      color: #565656;
    }
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 1.35em;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 0.9em;
  top: 6px;
  right: 17.5px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.tablet} {
    top: 6px;
    font-size: 1.4em;
  }

  ${mediaMaxWidth.smallPhone} {
    top: 7px;
    font-size: 1.2em;
  }
`;

export const Header = styled.div`
  position: absolute;
  font-size: 0.8em;
  top: 5px;
  border-bottom: 1px solid rgb(216, 216, 216);
  display: flex;
  flex: 1;
  width: 150px;
  margin: 0 5px;
  padding: 3px 7.5px;
  font-weight: 600;

  ${mediaMaxWidth.tablet} {
    font-size: 1em;
    width: calc(100vw - 20px);
    padding: 5px 7.5px;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.9em;
  }
`;
